import { Link } from 'react-router';
import { ArrowRight, GraduationCap, Sprout, Wrench } from 'lucide-react';
import { manifest } from '@/components/docs/docs-manifest';

const roleMeta: Record<string, { icon: typeof Sprout; blurb: string }> = {
  student: {
    icon: Sprout,
    blurb: 'Learn how to use the Telegram bot and Mini App as a student — answer assignments, track your streak, and browse your progress.',
  },
  teacher: {
    icon: GraduationCap,
    blurb: 'Run the teacher dashboard — invite students, assign seeds, read reports, and segment your class with tags and the funnel.',
  },
  admin: {
    icon: Wrench,
    blurb: 'Operate the platform — manage the seed catalog, import/export content, monitor AI usage, and respond to incidents with the playbooks.',
  },
};

export default function DocsIndexPage() {
  return (
    <div className="mx-auto w-full max-w-5xl">
      <title>Practice Seeds Documentation</title>
      <meta
        name="description"
        content="Public documentation for the Practice Seeds platform — student, teacher, and admin guides."
      />
      <section className="py-10 text-center">
        <h1 className="text-4xl font-bold tracking-tight">Practice Seeds Documentation</h1>
        <p className="mt-3 text-lg text-muted-foreground">
          Role-scoped guides for students, teachers, and admins. Pick your path below.
        </p>
      </section>

      <section className="grid gap-4 md:grid-cols-3">
        {manifest.roles.map((role) => {
          const meta = roleMeta[role.slug] ?? { icon: Sprout, blurb: '' };
          const Icon = meta.icon;
          return (
            <Link
              key={role.slug}
              to={`/docs/${role.slug}`}
              className="group flex flex-col rounded-xl border bg-card p-6 transition-colors hover:border-primary hover:bg-accent"
            >
              <Icon className="h-8 w-8 text-primary" />
              <h2 className="mt-3 text-xl font-semibold">{role.label}</h2>
              <p className="mt-2 flex-1 text-sm text-muted-foreground">{meta.blurb}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary">
                Read the guide
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </span>
              <span className="mt-3 text-xs text-muted-foreground">
                {role.pages.length} {role.pages.length === 1 ? 'page' : 'pages'}
              </span>
            </Link>
          );
        })}
      </section>

      <section className="mt-12 rounded-xl border border-dashed p-6 text-sm text-muted-foreground">
        <p>
          Looking for something specific? Use the sidebar to browse every guide — the table of contents mirrors the structure of each role&apos;s README.
        </p>
      </section>
    </div>
  );
}
